import { ModelBase } from './model.base';
import { ShortCode } from './shortcode.type';


export class Organization extends ModelBase {
    callbackSat: any;
    callbackSms: any;
    contact: string;
    isdeleted: boolean;
    name: string;
    shortCodes: Array<ShortCode>;
}
